<script setup>
import { useManageJobStore } from '@/stores/useManageJob';

definePageMeta({
  middleware: ['validate-user-role', 'manage-jobs'],
});

const manageJobStore = useManageJobStore();

onUnmounted(() => {
  manageJobStore.clearSelectedJob();
  manageJobStore.clearNotification();
});
</script>
